import * as React from 'react';
import {connect} from "react-redux";

class GlobalSearchHelpToolTip extends React.Component {
    render(): React.ReactNode {
        return (
            <i style={{color: "orange", marginRight: 4}}
               className="fas fa-question-circle fa-1x global-search-tooltip ag-help-question-mark">
                <div className="global-search-tooltip-tooltiptext">
                    <table>
                        <thead>
                        <tr>
                            <th>EXPR</th>
                            <th>RULE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>phrase</td>
                            <td>CONTAINS</td>
                        </tr>
                        <tr>
                            <td>!phrase</td>
                            <td>DOES NOT CONTAIN</td>
                        </tr>
                        <tr>
                            <td>phrase=</td>
                            <td>CONTAINS EXACT</td>
                        </tr>
                        <tr>
                            <td>!phrase=</td>
                            <td>DOES NOT CONTAIN EXACT</td>
                        </tr>
                        <tr>
                            <td>expr1 expr2</td>
                            <td>LOGICAL AND</td>
                        </tr>
                        <tr>
                            <td>expr1 & expr2</td>
                            <td>LOGICAL AND</td>
                        </tr>
                        <tr>
                            <td>expr1 && expr2</td>
                            <td>LOGICAL AND</td>
                        </tr>
                        <tr>
                            <td>expr1 | expr2</td>
                            <td>LOGICAL OR</td>
                        </tr>
                        <tr>
                            <td>expr1 || expr2</td>
                            <td>LOGICAL OR</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </i>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {}
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearchHelpToolTip)



// WEBPACK FOOTER //
// ./app/components/bo-core/common/GlobalSearchHelpToolTip.tsx